import { render, staticRenderFns } from "./RoleGuard.vue?vue&type=template&id=9c0f3012"
import script from "./RoleGuard.vue?vue&type=script&lang=ts"
export * from "./RoleGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports